import { useSelector } from 'react-redux';
import { appState, PlatformVersionInfo } from '../interfaces/common';
import { versionParser } from '../utils/helpers';

export const usePlatformVersionSelector = (): PlatformVersionInfo => {
  const platformVersion = useSelector((state: appState) => state.platformVersion);
  if (platformVersion) {
    return versionParser(platformVersion);
  }
  return {};
};

export const useSupportedLanguagesSelector = () => {
  const languages = useSelector((state: appState) => state.languagesSupported);
  const languageSet = new Set();
  return languages
    ? languages.reduce((twoCharLanguageList: any, language) => {
        const twoCharLang = language.substring(0, 2);
        if (!languageSet.has(twoCharLang)) {
          languageSet.add(twoCharLang);
          twoCharLanguageList.push(twoCharLang);
        }
        return twoCharLanguageList;
      }, [])
    : undefined;
};

export const useChatInfoSelector = () => useSelector((state: appState) => state.chatInfo);

export const useSessionIdSelector = () => useSelector((state: appState) => state.sessionId);
